import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/customers/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { Breadcrumbs } from "@mui/material"
import { useState } from "react"
import { useAppSelector } from "@/lib/hooks"

export default function CustomerList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Customers" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Customers</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <CustomerTable />
      </CrudProvider>
    </>
  )
}

function CustomerTable() {
  const { openDialog } = useCrudContext()
  const permissions = new Set(
    useAppSelector((state) => state.auth.user?.permissions ?? [])
  )

  return (
    <>
      <CustomTable
        label="Customer"
        columns={columns}
        apiPath="customer"
        addBtn={permissions.has("business-customers-create")}
        showEdit={permissions.has("business-customers-update")}
        showDelete={permissions.has("business-customers-delete")}
        showImport={
          permissions.has("operations-imports-create") &&
          permissions.has("business-customers-create")
        }
        onExport={permissions.has("operations-exports-create")}
      />

      {openDialog ? <AddContactModal /> : null}
    </>
  )
}
